import { createContext } from "react";

/**
 * True, gdy komponenty renderują się wewnątrz OKNA MODALNEGO (dostarczane przez
 * ModalLayout). Używane, by preferencję „Wygląd pól" ograniczyć do modali — wymiary
 * pól robi CSS ograniczony do kontenerów modali (global.scss), a WARIANT pola
 * (wypełnione/konturowe), którego nie da się ograniczyć samym CSS, components/Input
 * stosuje z ustawienia tylko gdy InModalContext === true; poza modalem używa bazowego
 * wariantu (wypełniony), więc zmiana ustawienia nie wycieka na pola nad gridami.
 */
export const InModalContext = createContext(false);

export default InModalContext;
